import Konva from "konva";
import type { RenderNode } from "../domain/renderSpec";
import { renderSpecToLayer } from "../ui/konvaRenderer";

// 描画仕様から基準サイズ原寸の PNG を生成する。
// 編集キャンバスの表示倍率に関わらず原寸で描画するため、小画面端末でも出力品質が落ちない
export async function exportPng(
  spec: RenderNode[],
  width: number,
  height: number,
): Promise<Blob> {
  const container = document.createElement("div");
  container.style.display = "none";
  document.body.appendChild(container);
  const stage = new Konva.Stage({ container, width, height });
  const layer = new Konva.Layer();
  stage.add(layer);
  try {
    renderSpecToLayer(spec, layer, false);
    layer.draw();
    const canvas = stage.toCanvas({ pixelRatio: 1 });
    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, "image/png"),
    );
    if (!blob) throw new Error("画像の生成に失敗しました。");
    return blob;
  } finally {
    stage.destroy();
    container.remove();
  }
}
